module.exports = __webpack_public_path__ + "static/media/header-phone.86d3d7d4.svg";